module.exports = __webpack_public_path__ + "img/lottie-step-1.12e38d91.png";